import Http from "@/utils/request.js";

//公告列表
export function NoticeList(data){
	return Http.request({
		url: `/user/message/getMessageList`,
		method: 'post',
		data
	})
}

//公告详情
export function NoticeDetails(id){
	return Http.request({
		url: `/user/message/getMessageDetail`,
		method: 'post',
		data:{
			id
		}
	})
}

//弹出公告
export function NoticeMessagePopup(data){
	return Http.request({
		url: `/user/message/getEject`,
		method: 'post',
		data
	})
}

// 站内信列表
export function MessageLetterList(data){
	return Http.request({
		url: `/user/messageLetter/getList`,
		method: 'post',
		data
	})
}

// 标记站内信已读（ids: number[] 或 all: true）
export function MessageLetterRead(data){
	return Http.request({
		url: `/user/messageLetter/read`,
		method: 'post',
		data
	})
}

// 未读站内信数量
export function MessageLetterUnreadCount(){
	return Http.request({
		url: `/user/messageLetter/countUnread`,
		method: 'post',
		data: {}
	})
}

